import { Link } from 'react-router'
import type { Pfad } from '../api/typen'

/** 'sonderfall' steht neben 'schrank' unter dem Versorgungspunkt: der VP ist verlinkt, ein Schrank fehlt. */
export type Ebene = 'erfassung' | 'versorgungspunkt' | 'schrank' | 'fach' | 'sonderfall'

interface Eigenschaften {
  pfad: Pfad
  /** Auf welcher Ebene der Anwender gerade steht; sie wird nicht verlinkt. */
  ebene: Ebene
  /** Zusätzliche letzte Stufe ohne Verweis, etwa die Fachkennung oder "Ergebnis". */
  zusatz?: string
}

/**
 * Schmale Pfadleiste unter der Kopfzeile. Der Zurück-Pfeil führt immer nur eine Ebene nach oben;
 * hier lässt sich in einem Schritt bis zum Standort oder zum Start springen. Die Leiste scrollt
 * waagerecht, damit sie auch auf einem schmalen Gerät eine Zeile bleibt.
 */
export default function Brotkrumen({ pfad, ebene, zusatz }: Eigenschaften) {
  const stufen: { text: string; ziel?: string }[] = [{ text: 'Start', ziel: '/' }]

  stufen.push({
    text: pfad.standort,
    ziel: ebene === 'erfassung' ? undefined : `/erfassungen/${pfad.erfassungId}`,
  })

  if (pfad.versorgungspunktId && ebene !== 'erfassung') {
    stufen.push({
      text: pfad.versorgungspunkt ?? 'Versorgungspunkt',
      ziel: ebene === 'versorgungspunkt' ? undefined : `/versorgungspunkte/${pfad.versorgungspunktId}`,
    })
  }

  if (pfad.schrankId && (ebene === 'schrank' || ebene === 'fach')) {
    stufen.push({
      text: pfad.schrank ?? 'Schrank',
      ziel: ebene === 'schrank' ? undefined : `/schraenke/${pfad.schrankId}`,
    })
  }

  if (zusatz) {
    stufen.push({ text: zusatz })
  }

  return (
    <nav className="brotkrumen" aria-label="Pfad">
      {stufen.map((stufe, index) => (
        <span key={`${stufe.text}-${index}`}>
          {index > 0 && <span className="trenner">›</span>}
          {stufe.ziel ? <Link to={stufe.ziel}>{stufe.text}</Link> : <b>{stufe.text}</b>}
        </span>
      ))}
    </nav>
  )
}
